import { FormControl, FormField, FormItem, FormLabel } from "../ui/form";
import type { FieldValues, Path, UseFormReturn } from "react-hook-form";
import { MultiSelectLocationSearch } from "../ui/multi-select-location-search";

type FormMultiSelectProps<T extends FieldValues> = {
	form: UseFormReturn<T>;
	name: Path<T>;
	label?: string;
	placeholder: string;
	options: {
        placeId: string;
        address: string;

	}[];
	fetcher?: (searchQuery:string) => void;
	fetching?: boolean;

};

export const FormMultiSelectLocation = <T extends FieldValues>({
	form,
	name,
	label,
	placeholder,
	options,
	fetcher,
	fetching,
}: FormMultiSelectProps<T>) => {
	return (
		<FormField
			control={form.control}
			name={name}
			render={({ field }) => (
				<FormItem>
					<FormLabel className="flex items-center gap-1 font-semibold">
						{label}
					</FormLabel>
					<FormControl>
						<MultiSelectLocationSearch
							fetcher={fetcher}
							fetching={fetching}
							className="py-5 pl-4 border border-border rounded-xl font-semibold placeholder:text-secondary resize-none"
							placeholder={placeholder}
							defaultValue={
								field.value
									? field.value
									: []
							}
							{...field}
							options={[
								...options.map((option) => ({
									placeId: option.placeId,
                                    address: option.address,
								})),
							]}
							onValueChange={(e) => {
								field.onChange(e);
							}}
						/>
					</FormControl>
				</FormItem>
			)}
		/>
	);
};
